import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { checkAuthToken, getaccessToken } from '../../infrastructure/backendService';

const ReportSection = () => {

  const navigate = useNavigate();

  useEffect(()=>{
     if(!checkAuthToken()) {
        navigate('/')
     }
  },[getaccessToken()])

  const users = [
   { id: 1, fullName: 'Devotee Sponsorship Report' },
   { id: 2, fullName: 'Devotee Information' },
   { id: 3, fullName: 'Devotee Donations Reports' },
   { id: 4, fullName: 'Pooja Report' },
   { id: 5, fullName: 'Priest Report' },
   { id: 6, fullName: 'Treasury Report' },
   { id: 7, fullName: 'System Report' },
   { id: 8, fullName: 'Volunteers' },
   { id: 9, fullName: 'Event Regstration' },
   { id: 10, fullName: 'Front Desk' }
 ];
  return (
    <div>
    <Typography component="div" sx={{
        color: "#414141",
        fontFamily: "Lato",
        fontSize: "28px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "140%"
    }}>
        Reports Section
     </Typography>
     <Outlet />
  </div>
  )
}

export default ReportSection